import type { FilterGroup } from '@jane/bloom/viewModels/productSearchFilters';

export function isRootCategoryFilterGroup({
  filterKey,
  filterValues,
}: FilterGroup) {
  return (
    filterKey === 'categories' &&
    !filterValues.some((value) => value.includes(':'))
  );
}
